import React from "react";
import { History } from "lucide-react";

// "Scenarios (n)" pill — opens Scenario History. No hover hint (scenario details show only inside the modal).
export function ScenariosPill({ scenarioCount, onOpenHistory }) {
  return (
    <button
      onClick={onOpenHistory}
      className="flex items-center gap-1 bg-white hover:bg-navy-wash px-2 py-0.5 text-[11px] font-semibold rounded-[3px]"
      style={{ border: "0.5px solid #4A5560", color: "#4A5560" }}
      data-testid="raag-scenarios-btn"
    >
      <History size={11} /> Scenarios ({scenarioCount || 0})
    </button>
  );
}
